import { ApiV2Organization } from '~/api/v2/organizations/get-type';
import { Button } from '~/components/Button/Button';
import { CardOrg } from '~/components/Card/CardOrg';

const Card = ({ organization }: { organization: ApiV2Organization }) => {
  return (
    <CardOrg
      companyLogo={organization.logo}
      link={`/orgs/${organization.uid}`}
      companyName={organization.name}
      title={organization.mission}
      areaText={organization.area}
      categoryList={organization.tags.map((tag) => tag.name)}
    />
  );
};

export const Orgs = ({ organizations }: { organizations: ApiV2Organization[] }) => {
  return (
    <div className='flex flex-col items-center gap-14 py-14'>
      <p className='text-title-strong-medium__sp text-accent lg:text-title-strong-medium'>
        参画する社会起業家
      </p>
      <div className='flex flex-row flex-wrap justify-center gap-4'>
        {organizations.map((organization) => (
          <Card key={organization.id} organization={organization} />
        ))}
      </div>
      <Button variant={'basic'} isShowArrowIcon link={{ href: '/orgs/intilaq' }}>
        もっと見る
      </Button>
    </div>
  );
};
